// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-badge {
  margin-top: -12px;
  margin-left: 3px;
  position: fixed;
  padding: 4px 7px 4px 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/chat/chat.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;AACF","sourcesContent":["ion-badge {\n  margin-top: -12px;\n  margin-left: 3px;\n  position: fixed;\n  padding: 4px 7px 4px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
